export default __webpack_public_path__ + "static/media/pin-hong-kong-railway-museum.b6ca7866.png";